const uuidV4 = require('uuid/v4');

export function isWexin() {
  const ua = navigator.userAgent;
  return /micromessenger/i.test(ua);
}

export function isAndroid() {
  const ua = navigator.userAgent;
  return /(Android);?[\s/]+([\d.]+)?/.test(ua);
}

export function isIOS() {
  const ua = navigator.userAgent;
  const isIpad = /(iPad).*OS\s([\d_]+)/.test(ua);
  const isIpod = /(iPod)(.*OS\s([\d_]+))?/.test(ua);
  const isIphone = !isIpad && /(iPhone\sOS)\s([\d_]+)/.test(ua);
  return isIpad || isIpod || isIphone;
}

export function getUrlQueryParams(url) {
  const params = {};
  const urls = url || location.href;
  const regex = /[?&]([\w]+)=([^&#]*)/g;
  let results;
  // eslint-disable-next-line no-cond-assign
  while ((results = regex.exec(urls)) != null) {
    params[decodeURIComponent(results[1])] = decodeURIComponent(results[2]);
  }
  return params;
}

export function appInit() {
  // 设置不同平台的字体
  if (isIOS()) {
    document.body.style.fontFamily = 'PingFang SC Regular';
  } else if (isAndroid()) {
    document.body.style.fontFamily = 'NoteSansCJKsc-Regular';
  } else {
    document.body.style.fontFamily = 'Microsoft Yahei';
  }
}

export function dateFormat(numberDate) {
  let tempDate = numberDate;
  if (!tempDate) return '';
  if (typeof (tempDate) !== 'string') {
    tempDate = tempDate.toString();
  }
  if (tempDate) {
    if (tempDate.length === 4) {
      return `${tempDate.slice(0, 4)}年`;
    }
    if (tempDate.length === 6) {
      return `${tempDate.slice(0, 4)}年${tempDate.slice(4)}月`;
    }
    if (tempDate.length === 8) {
      return `${tempDate.slice(0, 4)}年${tempDate.slice(4, 6)}月${tempDate.slice(6, 8)}日`;
    }
  }
  return '';
}

/** ************************************时间格式化处理*********************************** */
export function dateFt(format, date) { // author: meizz
  let fmt = format;
  const o = {
    'M+': date.getMonth() + 1,                 // 月份
    'd+': date.getDate(),                    // 日
    'h+': date.getHours(),                   // 小时
    'm+': date.getMinutes(),                 // 分
    's+': date.getSeconds(),                 // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(),             // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
    }
  });
  return fmt;
}

export function generateUUID() {
  return uuidV4();
}



// WEBPACK FOOTER //
// ./src/utils/util.js